import { render, staticRenderFns } from "./ImportTypeModal.vue?vue&type=template&id=66626568&scoped=true"
import script from "./ImportTypeModal.vue?vue&type=script&lang=ts"
export * from "./ImportTypeModal.vue?vue&type=script&lang=ts"
import style0 from "./ImportTypeModal.vue?vue&type=style&index=0&id=66626568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66626568",
  null
  
)

export default component.exports